import { enum as enumFactory, strictObject } from "../../lazy-zod.js";
//#region src/schemas/protocol/space-caller-context.ts
const spaceCallerContextSchema = strictObject({
	relationship: enumFactory([
		"internal",
		"external",
		"anonymous",
		"agent",
		"system"
	]),
	spaceRole: enumFactory([
		"owner",
		"member",
		"visitor"
	]),
	audience: enumFactory(["organization", "external"])
});
//#endregion
export { spaceCallerContextSchema };

//# sourceMappingURL=space-caller-context.js.map